/**
 * Sends a metric
 * @param {string} eventName
 * @param {string} url
 */
export async function sendMetric(eventName, url) {
  try {
    const timestamp = Date.now()

    /** @type {FunnelMetricBody}  */
    const payload = {
      eventName,
      timestamp,
      url,
    }
    const body = JSON.stringify(payload)
    const response = await fetch('https://ops.trbotrkr.com/metrics/events', {
      body,
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })

    if (!response.ok) {
      throw Error(
        response.statusText || `${response.status}`.trim() || 'Unknown error',
      )
    }
  } catch (error) {
    console.error(error)
  }
}
